import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment as ENV } from '../../environments/environment';

import { IThesisReport, IThesisReportDoctor, IThesisReportEditModel, IThesisReportListItem, IThesisReportSummary } from '../models/ThesisReport';

/**
 * Thesis report service
 */
@Injectable({ providedIn: "root" })
export class ThesisReportService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/thesisReports` }

    get(): Observable<IThesisReportListItem[]> {
        return this.http.get<IThesisReportListItem[]>(this.apiUrl);
    }

    getById(id: number): Observable<IThesisReport> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<IThesisReport>(url);
    }

    getDoctors(): Observable<IThesisReportDoctor[]> {
        const url = `${this.apiUrl}/doctors`;
        return this.http.get<IThesisReportDoctor[]>(url);
    }

    create(model: IThesisReportEditModel): Observable<number> {
        const url = `${this.apiUrl}`;
        return this.http.post<number>(url, model);
    }

    update(id: number, model: IThesisReportEditModel): Observable<number> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.put<number>(url, model);
    }

    delete(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete(url);
    }

    submit(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/submit`;
        return this.http.post(url, null);
    }

    addAttachment(id: number, file: File): Observable<number> {
        const url = `${this.apiUrl}/${id}/attachments`;
        const form = new FormData();

        form.append('file', file, file.name);

        return this.http.post<number>(url, form);
    }

    removeAttachment(fileId: number): Observable<any> {
        const url = `${this.apiUrl}/attachments/${fileId}`;
        return this.http.delete(url).pipe(map(res => res));
    }

    getAttachment(fileId: number): Observable<any> {
        const url = `${this.apiUrl}/attachments/${fileId}`;
        return this.http.post(url, null, { responseType: 'blob' as 'json' });
    }

    getSummary(): Observable<IThesisReportSummary> {
        const url = `${this.apiUrl}/summary`;
        return this.http.get<IThesisReportSummary>(url);
    }
}
